export default __webpack_public_path__ + "static/media/du.faa16d29.svg";